import { Controller } from 'stimulus';

class FileInputController extends Controller {
  onFileUpload() {
    let fileName = '';

    if (this.inputTarget.files.length) {
      fileName = this.inputTarget.value.split('\\').pop();
    }

    if (!fileName) {
      this.fileNameOutputTarget.innerHTML = '';
    }

    this.fileNameOutputTarget.innerHTML = fileName;
  }
}

FileInputController.targets = [
  'label',
  'input',
  'fileNameOutput',
];

export default FileInputController;
